// import { GTMsendEvent } from "@/utils/trackingGA4";
import { Accordion, Card, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon/Icon";
import { GTMsendEvent } from "src/utils/trackingGA4";

const VehicleAccordion = ({ vehicle }) => {
    const { t } = useTranslation()

    return (
        <Card className="mt-3">
            <Card.Body>
                <Accordion className="technical-data" flush>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header
                            onClick={() => {
                                GTMsendEvent({
                                    event: 'cta_accordion',
                                    category: 'accordion',
                                    action: 'click',
                                    label: 'Motore',
                                    item_name: `${vehicle.dati_veicolo.marca} ${vehicle.dati_veicolo.allestimento}`,
                                });
                            }}
                        >
                            <Icon name="engine" /> {t('engine')}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className="details-list">
                                <Col sm={6}>
                                    <small>{t('cylinder_capacity')}</small>
                                    <div>{vehicle?.dati_veicolo.cilindrata || '-'} {t('cylinder_capacity_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('horsepower')}</small>
                                    <div>{vehicle?.dati_veicolo.cavalli || '-'} {t('horsepower_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('fuel_type')}</small>
                                    <div>{vehicle?.dati_veicolo.alimentazione || '-'}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('kw')}</small>
                                    <div>{vehicle?.dati_veicolo.kw || '-'} {t('kw_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('vehicle_gear')}</small>
                                    <div>{vehicle?.dati_veicolo.cambio || '-'}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('vehicle_drive_system')}</small>
                                    <div>{vehicle?.dati_veicolo.trazione || '-'}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('engine_torque')}</small>
                                    <div>{vehicle?.dati_veicolo.coppia || '-'}</div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header
                            onClick={() => {
                                GTMsendEvent({
                                    event: 'cta_accordion',
                                    category: 'accordion',
                                    action: 'click',
                                    label: 'Dimensioni',
                                    item_name: `${vehicle.dati_veicolo.marca} ${vehicle.dati_veicolo.allestimento}`,
                                });
                            }}
                        >
                            <Icon name="car-size" />{t('dimensions')}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className="details-list">
                                <Col sm={6}>
                                    <small>{t('doors').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.porte || '-'}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('seats').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.posti || '-'}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('length').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.lunghezza || '-'} {t('centimeters_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('width').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.larghezza || '-'} {t('centimeters_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('height').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.altezza || '-'} {t('centimeters_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('luggage_capacity').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.capacita_vano_carico || '-'} L
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header
                            onClick={() => {
                                GTMsendEvent({
                                    event: 'cta_accordion',
                                    category: 'accordion',
                                    action: 'click',
                                    label: 'Prestazioni',
                                    item_name: `${vehicle.dati_veicolo.marca} ${vehicle.dati_veicolo.allestimento}`,
                                });
                            }}
                        >
                            <Icon name="speedometer" /> {t('performance')}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className="details-list">
                                <Col sm={6}>
                                    <small>{t('speed').toUpperCase()}</small>
                                    <div>{vehicle?.dati_veicolo.velocita || '-'}{t('km_h_short').toUpperCase()}</div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('acceleration').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.accelerazione || '-'} {t('seconds_short')}
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header
                            onClick={() => {
                                GTMsendEvent({
                                    event: 'cta_accordion',
                                    category: 'accordion',
                                    action: 'click',
                                    label: 'Consumi ed emissioni',
                                    item_name: `${vehicle.dati_veicolo.marca} ${vehicle.dati_veicolo.allestimento}`,
                                });
                            }}
                        >
                            <Icon name="fuel" />
                            {t('fuel_consumption_and_emissions')}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className="details-list">
                                <Col sm={6}>
                                    <small>{t('average_consumption').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.consumo_medio || '-'} {t('liters_100_km').toUpperCase()}
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('urban_consumption').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.consumo_urbano || '-'} {t('liters_100_km').toUpperCase()}
                                    </div>
                                </Col>

                                <Col sm={6}>
                                    <small>{t('urban_extra_consumption').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.consumo_extra_urbano || '-'}{' '}
                                        {t('liters_100_km').toUpperCase()}
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    <small>{t('co2_emissions').toUpperCase()}</small>
                                    <div>
                                        {vehicle?.dati_veicolo.emissioni_co2 || '-'} {t('g_km').toUpperCase()}
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header
                            onClick={() => {
                                GTMsendEvent({
                                    event: 'cta_accordion',
                                    category: 'accordion',
                                    action: 'click',
                                    label: 'Optional',
                                    item_name: `${vehicle.dati_veicolo.marca} ${vehicle.dati_veicolo.allestimento}`,
                                });
                            }}
                        >
                            <Icon name="list" /> {t('optional')}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row className="details-list">
                                {vehicle?.optionals?.map((o, i) => (
                                    <Col key={i} xs={12}>
                                        {o.descrizione} ({o.codice_costruttore})
                                        <span className="float-end">
                                            €
                                            {(o.valore || 0)?.toLocaleString('it', {
                                                minimumFractionDigits: 2,
                                            })}
                                        </span>
                                    </Col>
                                ))}
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card.Body>
        </Card>
    )
}

export default VehicleAccordion
